import { createContext } from 'react'

export const ViewingProfileContext = createContext(null)
